export const fixCoef = (coef: string | number, minCoef: number, maxCoef: number): number => {
    if (Number(coef) < minCoef) {
        return minCoef;
    }
    if (Number(coef) > maxCoef) {
        return maxCoef;
    }
    return Number(coef);
};
